// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Botswana */
const BW = /^(?:(?:321|7(?:[1-8]\d|9[03]))\d{5})$/;

export default BW;
